// MST1020_R01 BOM 관련 유틸리티 함수 및 상수

import { allowedAccountsArr } from "src/components/common/common";
import { showWarning } from "src/utils/toast/toastUtil";
import { KSK2030_R01Dto } from "./Dto_KSK2030_R01";


export const headerNames_KSK2030_R01: Record<string, string> = {
	rowIndex: "",
	productOrderNo: '작업지시번호',
	compCd: '사업장',
	orderDt: '작업일자',
	orderType: '지시구분',
	workplaceCd: '작업공정',
	workProcess: '공정유형',
	jobTeam: '작업팀',
	orderEmp: '작업자',
	orderEmpNm: '작업자(명)',
	itemCd: '품목코드',
	itemNm: '품명',
	itemSpec: '규격',
	itemUnit: '단위',
	orderQty: '수량',
	lossPercent: '불량률(%)',
	remark: '비고',
}

export const headerNames_KSK2030_R01_Detail: Record<string, string> = {
	rowIndex: "",
	productWorkNo: '공정지시번호',
	downtimeNo: '비가동시간번호',
	downtimeCase: '비가동사유',
	downtimeStartTime: '비가동시작시간',
	downtimeEndTime: '비가동종료시간',
}

// 원본 데이터 복구 함수
export function restoreOriginalValues(
  valueIndex: number,
  originalData: KSK2030_R01Dto,
  updateKSK2030_R01List: (index: number, data: KSK2030_R01Dto) => void,
  gridRef: any
) {
  setTimeout(() => {
    updateKSK2030_R01List(valueIndex, {
      ...originalData,
      isModified: originalData.inserted === true ? false : true
    });
    if (gridRef.current?.api) {
      const allRowNodes: any[] = [];
      gridRef.current.api.forEachNode((node: any) => {
        if (node.data && node.data.valueIndex === valueIndex) {
          allRowNodes.push(node);
        }
      });
      if (allRowNodes.length > 0) {
        const targetNode = allRowNodes[0];
        targetNode.setDataValue('itemCd', originalData.itemCd);
        targetNode.setDataValue('itemNm', originalData.itemNm);
        targetNode.setDataValue('itemSpec', originalData.itemSpec);
        targetNode.setDataValue('itemUnit', originalData.itemUnit);
      }
    }
  }, 100);
}

// 행 편집 가능 여부
export function isEditableRow(
  params: any,
  originalKSK2030_R01List: KSK2030_R01Dto[],
  deletedMST1020_R01BomDetailList: (string | number)[]
): boolean {
  if (params.data?.inserted) return true;
  const originalData = originalKSK2030_R01List.find(item => item.valueIndex === params.data?.valueIndex);
  return true;
}

// 날짜 컬럼 클릭 시 편집 가능 여부
export function validateDateColumns(
  field: string,
  data: any,
  originalKSK2030_R01List: KSK2030_R01Dto[],
  dateColumns: string[]
): boolean {
  const originalData = originalKSK2030_R01List.find(item => item.valueIndex === data.valueIndex);
  return true;
}

// 품목 계정 검증
export function validateItemAccount(itemAccount: string) {
  return allowedAccountsArr.includes(itemAccount);
}

// 중복 체크
export function isDuplicateChildItemcd(
  list: KSK2030_R01Dto[],
  itemCd: string,
  valueIndex: number
) {
  return list.filter(item => item.itemCd === itemCd && item.valueIndex !== valueIndex).length > 0;
} 